import { useEffect, useRef, useState } from "react";

import { Observation } from "@medplum/fhirtypes";

import {
  LABOR_QUESTIONNAIRE_DISPLAY_NAMES,
  QuestionnaireType,
} from "@/encounters/components/EncounterLabor/constants/labor-questionnaires";
import { useLaborFlowsheetEditRouteContext } from "@/encounters/components/EncounterLabor/EncounterLaborTable/LaborRow/Common/use-labor-flowsheet-edit-route-context";
import { LaborVitalsFlowsheetDrawer } from "@/encounters/components/EncounterLabor/flowsheet-forms/labor-vitals";

interface EditLaborVitalsLaborRowProps {
  observation: Observation;
  onClose?: () => void;
}

export default function EditLaborVitalsLaborRow({
  observation,
  onClose,
}: EditLaborVitalsLaborRowProps) {
  const [opened, setOpened] = useState(true);
  const { encounterId, clientId, hasRouteContext } = useLaborFlowsheetEditRouteContext(onClose);
  const questionnaireDisplayName =
    observation.code?.coding?.[0]?.display ??
    LABOR_QUESTIONNAIRE_DISPLAY_NAMES[QuestionnaireType.LaborVitals];

  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    if (hasRouteContext) {
      return;
    }
    setOpened(false);
  }, [hasRouteContext]);

  const handleClose = () => {
    setOpened(false);
    onCloseRef.current?.();
  };

  if (!hasRouteContext || !encounterId || !clientId) {
    return null;
  }

  return (
    <LaborVitalsFlowsheetDrawer
      mode="edit"
      opened={opened}
      clientId={clientId}
      onClose={handleClose}
      encounterId={encounterId}
      observation={observation}
      title={questionnaireDisplayName}
      questionnaireDisplayName={questionnaireDisplayName}
    />
  );
}
